import type { TenantInstance } from '@omni/instance'
import { applyFrontDoorBuild } from '@omni/front-door'
import { nateva } from './nateva'

// Active-instance resolver for Nateva's single-tenant build, swapped in for
// active.default.ts via the '@shell-active-instance' alias when
// VITE_INSTANCE_SLUG=nateva (vite.config.ts). The bundle imports ONLY
// Nateva's own instance (zero-carryover rule, 2026-09-01).
//
// One build per app (doc customer-front-door, section 4): VITE_FRONT_DOOR_APP
// unset is the front-door site (Apps, Programme, Using Claude); set to an
// app's slug it is that app's own build with that app's tabs. vite.config.ts
// refuses an unknown slug before the build starts.
export const activeInstance: TenantInstance = applyFrontDoorBuild(
  nateva,
  import.meta.env.VITE_FRONT_DOOR_APP || undefined,
)
